import React from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { setMemo, setMemoAct } from '../../../store/ToolSlice';
import { Text } from '../../_atoms/Text';
import { ImageButton } from '../ImageButton';

const MemoWrap = styled.div`
  background: center /contain no-repeat;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: left 0.3s;
  z-index: 4;
  width: 328px;
  height: 348px;
  background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/memo/memo.png);

  &:active {
    cursor: move;
  }
`;

export const Memo = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const onMemoText = (e) => {
    dispatch(setMemo(e.target.value));
  };
  
  return (
    <Draggable bounds="parent" scale={state.common.zoom}>
      <MemoWrap>
        <Text 
          type="memo" 
          tabIndex={100} 
          maxLength={1000}
          onChange={(e) => onMemoText(e)}
        >
          {state.tool.memo}
        </Text>
        <ImageButton 
          type="memoClose" 
          src="https://content.chungchy.com/PhonicsHero/web_resource/images/memo/memo_btn_close.png" 
          alt="메모 닫기"
          onClick={() => dispatch(setMemoAct(false))}
        />
       </MemoWrap>
    </Draggable>
    );
};